import { fetchCoGuardian } from '@/services/get-co-guardian';
import { useQuery } from '@tanstack/react-query';

export const coGuardianKeys = {
  all: ['co-guardian'] as const,
  detail: (playerId?: string, guardianUid?: string) =>
    [...coGuardianKeys.all, playerId ?? null, guardianUid ?? null] as const,
};

/**
 * A single co-guardian's profile (details + mutual kids) for a player, from
 * GET `/api/v1/guardians/me/players/{playerId}/guardians/{guardianUid}`. Gated on both
 * ids so it only fires once the target member is known.
 */
export function useCoGuardianQuery(playerId?: string, guardianUid?: string) {
  return useQuery({
    queryKey: coGuardianKeys.detail(playerId, guardianUid),
    queryFn: () => fetchCoGuardian(playerId as string, guardianUid as string),
    enabled: Boolean(playerId) && Boolean(guardianUid),
  });
}
